
import { mapState, mapActions } from 'vuex';
import ReviewContentType from '@/enums/ReviewContentType';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
import FocusFirstNewReview from '@/mixins/FocusFirstNewReview';

export default {
  i18nComponentKey: 'WidgetProductReviewsListV3.components.BodyPc',
  name: 'BodyPc',
  emits: ['reported'],
  mixins: [FocusFirstNewReview],
  props: {
    reviews: {
      type: Array,
      required: true
    },
    popupParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('widget', ['widget']),
    DropdownMenuWidth: () => DropdownMenuWidth,
    bodyStyle() {
      return {
        '--min-height': this.widget.show_filter_section ? '204px' : 'auto'
      };
    }
  },
  methods: {
    ...mapActions('review', ['handleEditOrDeleteReview']),
    editOrDeleteOptions(review) {
      return [
        review.editable
          ? { name: this.$t('app.edit_review'), value: 'edit' }
          : null,
        review.deletable
          ? {
              name: this.$t('app.delete_review'),
              value: 'delete',
              danger: true
            }
          : null
      ].filter(v => v);
    },
    showEditOrDelete(review) {
      return review.editable || review.deletable;
    },
    displayMediaSection(review) {
      return (
        review.content_type !== ReviewContentType.RESTRICTED &&
        review.media_count > 0
      );
    }
  }
};
